import React from 'react';
import { motion } from 'framer-motion';
const WHATSAPP_URL = 'https://wa.me/12679841013';
export const WhatsAppFloat = () => {
  return <motion.a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer" aria-label="Chatear por WhatsApp" initial={{
    opacity: 0,
    scale: 0.8,
    y: 20
  }} animate={{
    opacity: 1,
    scale: 1,
    y: 0
  }} transition={{
    delay: 1,
    duration: 0.5,
    ease: 'easeOut'
  }} whileHover={{
    scale: 1.08
  }} whileTap={{
    scale: 0.95
  }} className="fixed bottom-5 right-5 md:bottom-6 md:right-6 z-[60] flex items-center justify-center w-14 h-14 md:w-16 md:h-16 rounded-full bg-[#25D366] text-white shadow-[0_8px_24px_rgba(37,211,102,0.45)] hover:shadow-[0_10px_28px_rgba(37,211,102,0.55)] transition-shadow" data-id="element-418">
      {/* Pulsing ring */}
      <span className="absolute inset-0 rounded-full bg-[#25D366] opacity-60 animate-ping pointer-events-none" data-id="element-419"></span>

      {/* WhatsApp icon */}
      <svg viewBox="0 0 32 32" width="28" height="28" className="relative z-10 md:w-8 md:h-8" fill="currentColor" aria-hidden="true" data-id="element-420">
        <path d="M19.11 17.205c-.372 0-1.088 1.39-1.518 1.39a.63.63 0 0 1-.315-.1c-.802-.402-1.504-.817-2.163-1.447-.545-.516-1.146-1.29-1.46-1.963a.426.426 0 0 1-.073-.215c0-.33.99-.945.99-1.49 0-.143-.73-2.09-.832-2.335-.143-.372-.214-.487-.6-.487-.187 0-.36-.043-.53-.043-.302 0-.53.115-.746.315-.688.645-1.032 1.318-1.06 2.264v.114c-.015.99.472 1.977 1.017 2.78 1.23 1.82 2.506 3.41 4.554 4.34.616.287 2.035.802 2.722.802.587 0 1.834-.74 2.106-1.347.143-.32.244-.687.244-1.043 0-.488-1.503-1.262-1.879-1.434-.487-.215-.6-.215-.747-.215zm-2.91 7.45c-1.92 0-3.797-.517-5.444-1.49l-3.797 1.218 1.232-3.682a10.5 10.5 0 0 1-1.643-5.658c0-5.847 4.788-10.617 10.65-10.617 5.864 0 10.654 4.77 10.654 10.617s-4.79 10.62-10.65 10.62zm0-23.082c-6.84 0-12.395 5.532-12.395 12.345 0 2.135.546 4.227 1.59 6.077L2 30l4.86-1.55a12.34 12.34 0 0 0 5.79 1.46h.014c6.83 0 12.467-5.532 12.467-12.345 0-3.297-1.42-6.395-3.762-8.732a12.41 12.41 0 0 0-8.804-3.61z" data-id="element-421" />
      </svg>
    </motion.a>;
};